import type { SuperAdminOverdueRequest } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import {
  inlineAssigneeCell,
  inlineComplexityCell,
  inlineDueDateCell,
  inlineStatusCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  dateCell,
  nameCell,
  requestDesignTypeCell,
} from "../../helpers/commonCells";

// Overdue Tab Configuration for SuperAdmin
// Columns: Name, Account, Assignee, Due, Status, Complexity, Created date, Request/Design type
export const overdueTableConfig: TableConfig<SuperAdminOverdueRequest> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: 220,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: 180,
    },
    {
      accessor: "assignee",
      cellRenderer: inlineAssigneeCell, // Inline editable
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: 160,
    },
    {
      accessor: "dueDate",
      cellRenderer: inlineDueDateCell, // Inline editable with internal due date logic
      header: "Due",
      key: "dueDate",
      sortable: true,
      width: 120,
    },
    {
      accessor: "status",
      cellRenderer: inlineStatusCell, // Inline editable
      header: "Status",
      key: "status",
      sortable: true,
      width: 180,
    },
    {
      accessor: "complexity",
      cellRenderer: inlineComplexityCell, // Inline editable
      header: "Complexity",
      key: "complexity",
      sortable: true,
      width: 120,
    },
    {
      accessor: "createdAt",
      cellRenderer: dateCell,
      header: "Created date",
      key: "createdAt",
      sortable: true,
      width: 130,
    },
    {
      accessor: "designType",
      cellRenderer: requestDesignTypeCell,
      header: "Request/Design type",
      key: "designType",
      sortable: true,
      width: 180,
    },
  ],
  defaultSort: {
    column: "dueDate",
    direction: "asc", // Most overdue first
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "superadmin-overdue-requests",
  title: "Overdue",
};
